module.exports = __webpack_public_path__ + "static/media/imageFileIcon.d70e7915.svg";